import { Condition, KeyValue, WarrantSortKeyByType, ResultSetHeader, Warrant, WarrantCode, WarrantCollectionCode, AllGroupAndRestaurantWarrant, } from '../../models';
import http, { HttpSuccessOrErrorType } from '../http';

export default {
    /**
     * 查看集团warrant资源。
     * @param string_id 餐厅string_id
     */
    async get_group_warrant_condition(params: { string_id: string, sort_value: string } & Omit<Condition, 'sort_value'> & KeyValue): Promise<HttpSuccessOrErrorType<AllGroupAndRestaurantWarrant>> {
        const { string_id, ...rest } = params;
        return await http.get(`/group/${string_id}/warrant/condition`, {
            params: {
                ...rest
            }
        })
    },

    /**
     * 删除集团warrant资源。
     * @param params 参数
     */
    async delete_group_warrant_ids(params: { string_id: string, ids: Array<string> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.delete(`/group/${string_id}/warrant`, {
            data: {
                ...rest
            }
        })
    },

    /**
     * 创建集团warrant资源。
     * @param params 参数
     */
    async create_group_warrant(params: Warrant & { string_id: string }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.post(`/group/${string_id}/warrants`, {
            ...rest
        })
    },

    /**
     * 查看集团静态warrant资源。
     * @param string_id 餐厅string_id
     */
    async get_group_static_warrant(params: { key: string, account_type: string }): Promise<HttpSuccessOrErrorType<WarrantSortKeyByType>> {
        return await http.get(`/warrant/static_warrant`, {
            params: {
                ...params
            }
        })
    },

    /**
     * 批量创建warrant资源。
     * @param params 参数
     */
    async create_group_warrants_collection(params: { string_id: string, code?: WarrantCode | WarrantCollectionCode, warrants: Array<Warrant> }): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        const { string_id, ...rest } = params;
        return await http.post(`/group/${string_id}/warrants_collection`, {
            ...rest
        })
    },

    /**
     * 获取授权点最优策略
     * @param account_type 餐厅 RESTAURANT  集团 GROUP
     */
    async getWarrantStrategy(params: { account_type: string, string_id: string, codes: string[] }): Promise<HttpSuccessOrErrorType<{ code: string, start_date: string, end_date: string }[]>> {
        return await http.get(`${params.account_type}/${params.string_id}/warrant/date/strategy`, {
            params: { codes: params.codes },
            data: []
        })
    },
    /**
     * 编辑授权点数量
     */
    async patchWarrantTotalnum(string_id: string, params: Warrant & { current_time_zone: string }): Promise<HttpSuccessOrErrorType<{ code: string, start_date: string, end_date: string }[]>> {
        return await http.patch(`/restaurant/${string_id}/warrants/total_num`, params)
    }
}
